import * as HttpService from './HttpService'

let namespace = 'possible-efforts'

let all = (params, cb, errorCb) => {
    HttpService.get(namespace, params, cb, errorCb)
}

export {
    all
}



// WEBPACK FOOTER //
// ./src/services/possibleEffortsService.js